import type { AxiosRequestConfig } from "axios";
import axios from "axios";
import { getSharedVariables } from "../variables";
import type {
  ExchangeAuthCodeRequest,
  LogoutRequest,
  LogoutResponse,
  RefreshAccessTokenRequest,
  TokenOperationResponse,
} from "./clients/ssoTypes";
import type { ApiResponse } from "./types";

const ssoApiBaseUri = `${getSharedVariables().PORTAL_BACKEND_BASE_URI}/sso`;

const requestToken = async (payload: ExchangeAuthCodeRequest) => {
  const { data } = await axios.post<ApiResponse<TokenOperationResponse>>(`${ssoApiBaseUri}/auth/codeExchange`, payload);
  return data;
};

const refreshToken = async (payload: RefreshAccessTokenRequest) => {
  const { data } = await axios.post<ApiResponse<TokenOperationResponse>>(`${ssoApiBaseUri}/auth/refresh`, payload, {
    skipAuthRefresh: true,
  } as AxiosRequestConfig);

  return data;
};

const logout = async (payload: LogoutRequest) => {
  const { data } = await axios.post<ApiResponse<LogoutResponse>>(`${ssoApiBaseUri}/auth/logout`, payload, {
    skipAuthRefresh: true,
  } as AxiosRequestConfig);

  return data;
};

export const ssoApi = {
  requestToken,
  refreshToken,
  logout,
};
